var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.698.127l-3.695.46a.156.156 0 00-.092.263l1.069 1.068-2.998 2.998a.157.157 0 000 .221l.88.881c.061.06.16.06.221 0l3-3 1.069 1.068a.155.155 0 00.263-.091L13.872.3a.155.155 0 00-.174-.174zM5.136 7.983a.157.157 0 00-.22 0l-2.999 3L.85 9.915a.155.155 0 00-.264.091L.126 13.7a.156.156 0 00.174.174l3.695-.46a.156.156 0 00.092-.263l-1.068-1.069 3-3c.06-.06.06-.16 0-.22l-.883-.88z",
    fill: "currentColor"
  })));
}

export default SvgExpand;